import React, { useMemo, useCallback, useEffect, useState } from 'react';
import {
  Form,
  notification,
  Popconfirm,
  Button as AntdButton,
  InputNumber,
  Input,
} from 'antd';
import { useQuery } from 'react-query';
import { useFormList } from '../../../hooks/useFormList';
import DataGrid, { DataGridColDef } from '../../DataGrid/DataGrid';
import {
  updateMyWorkingSession,
  UserSessionParameters,
  MguserlandingResponse,
  removeMguserlanding,
  addMguserlandingBymgidUserid,
  getMguserlandingBymgidUserid,
  UpdateMguserlanding,
} from '../../../services/parametersService';
import {
  getMyFavorite,
  MgUsersFavoriteResponse,
  removeFavorite,
  addFavorite,
} from '../../../services/workflow';
import { indexBy, setValueByNamePath } from '../../../utils/utils2';
import ListOfTasks from './ListOfTasks';
import { getCurrentUser } from 'utils/APIUtils';
import ParListSelect from 'components/ParListSelect';
import MgCompanyList from '../../MgCompanyList/index';
import Value from 'components/Value';
import i18next from 'i18next';
import { isEqual } from 'lodash';
import ParValueExternalSelect from 'components/ParValueExternalSelect';

const NEW_ACTION_ID = -1;
const NEW_CONFIG_ID = -1;

type Values = {
  actions: MguserlandingResponse[];
};
type ValuesActions = {
  actions: MgUsersFavoriteResponse[];
};

export type MyProfileProps = {
  onCancel?: () => void;
};

const LandingPageConfig = ({ onCancel }: MyProfileProps) => {
  const [Params] = useState<any>({
    part1show: false,
    part2show: false,
    part3show: false,
  });
  const [mgName, SetmgName] = useState<any>(localStorage.getItem('mgname'));

  const [configForm] = Form.useForm();
  const [myProfileForm] = Form.useForm();
  const [quickActionsForm] = Form.useForm();

  const fieldNameOfquickAction = 'actions';
  const fieldName = 'mg';

  const { data: user, isFetching } = useQuery(
    `getCurrentUser`,
    () =>
      getCurrentUser().then((res) => {
        return res;
      }),
    {
      refetchOnMount: true,
    }
  );

  const { data, refetch } = useQuery(
    ['getMguserlandingBymgidUserid', {}],
    () => getMguserlandingBymgidUserid().then((res) => res.list || []),
    { refetchOnMount: false }
  );
  const {
    data: dataAction,
    refetch: refetchAction,
    isFetching: isFetchingAction,
  } = useQuery(
    ['getMyFavorite', {}],
    () => getMyFavorite().then((res) => res.list || []),
    { refetchOnMount: false }
  );

  useEffect(() => {
    if (user) {
      myProfileForm.setFieldsValue({
        mgid: user?.mgid,
        lancode: user?.lancode,
        route: user?.route,
        tabposition: user?.tabposition,
        name: user?.name,
        username: user?.username,
        phone: user?.phone,
        mobile: user?.mobile,
        usertype: user?.usertype,
        surname: user?.surname,
        email: user?.email,
      });
    }
    if (data) {
      configForm.setFieldsValue({ [fieldName]: data });
    } else {
      configForm.setFieldsValue({
        [fieldName]: [],
      });
    }
    if (dataAction) {
      quickActionsForm.setFieldsValue({ [fieldNameOfquickAction]: dataAction });
    } else {
      quickActionsForm.setFieldsValue({
        [fieldNameOfquickAction]: [],
      });
    }
  }, [configForm, quickActionsForm, data, dataAction, user]);

  const { add, remove } = useFormList(configForm, fieldName, {
    idKey: 'partid',
    addAsFirst: true,
  });
  const { add: addd } = useFormList(quickActionsForm, fieldNameOfquickAction, {
    idKey: 'favoriteid',
    addAsFirst: true,
  });

  const getName = useCallback(
    (name: string) => (record: MguserlandingResponse) => {
      const actions = configForm.getFieldValue(fieldName);
      const index = indexBy(actions, 'partid')[record.partid];
      return [fieldName, index, name];
    },
    [configForm]
  );
  const getNameOfquickAction = useCallback(
    (name: string) => (record: MgUsersFavoriteResponse) => {
      const actions = quickActionsForm.getFieldValue(fieldNameOfquickAction);
      const index = indexBy(actions, 'favoriteid')[record.favoriteid];
      return [fieldNameOfquickAction, index, name];
    },
    [quickActionsForm]
  );
  const onSave = useCallback(
    (record: MguserlandingResponse) => {
      const functions: MguserlandingResponse[] =
        configForm.getFieldValue(fieldName);
      const index = indexBy(functions, 'partid')[record.partid];
      const currentValue = functions[index];

      const { mgid, partid } = currentValue;
      if (mgid) {
        partid === NEW_CONFIG_ID
          ? addMguserlandingBymgidUserid({
              request: {
                ...currentValue,
                partid: NEW_CONFIG_ID,
              },
            }).then((response) => {
              if (response.code === '200') {
                notification.success({
                  message: `Created`,
                });
                refetch();
              } else {
                notification.error({
                  message: response.message,
                  description: response.description,
                });
              }
            })
          : UpdateMguserlanding({
              partid: currentValue.partid,
              request: currentValue,
            }).then((response) => {
              if (response.code === '200') {
                notification.success({
                  message: response.message,
                });
                refetch();
              }
            });
      } else {
        notification.error({
          message: 'Please select Company',
        });
      }
    },
    [configForm, refetch]
  );

  const columns = useMemo<DataGridColDef<MguserlandingResponse>[]>(
    () => [
      {
        dataIndex: 'mgid',
        render: (value, record) => {
          return record.partid === NEW_CONFIG_ID ? (
            <Form.Item noStyle name={getName('mgid')(record)}>
              <MgCompanyList />
            </Form.Item>
          ) : (
            record.mgname
          );
        },
        width: 200,
      },
      {
        dataIndex: 'partorder',
        render: (value, record) => (
          <Form.Item noStyle name={getName('partorder')(record)}>
            <InputNumber max={5} min={1} step={1} />
          </Form.Item>
        ),
        width: 200,
      },

      {
        dataIndex: 'part1type',
        render: (value, record) => {
          Params.part1show = value !== 'Chart';
          return (
            <Form.Item noStyle name={getName('part1type')(record)}>
              <ParListSelect
                parcode="PARTTYPE"
                onChange={(e, k) => {
                  Params.part1show = e !== 'Chart';
                  if (e === 'SUPERSET') {
                    setValueByNamePath(
                      configForm,
                      getName('part1graph')(record),
                      ''
                    );
                    setValueByNamePath(
                      configForm,
                      getName('part1label')(record),
                      ''
                    );
                    setValueByNamePath(
                      configForm,
                      getName('part1view')(record),
                      ''
                    );
                    setValueByNamePath(
                      configForm,
                      getName('part1kpi')(record),
                      ''
                    );
                  }
                }}
                allowClear
              />
            </Form.Item>
          );
        },
        width: 200,
      },
      {
        dataIndex: 'part1width',
        render: (value, record) => (
          <Form.Item name={getName('part1width')(record)}>
            <InputNumber min={4} max={24} />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part1height',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part1height')(record)}>
            <Input min={100} max={800} />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part1label',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part1label')(record)}>
            <Input />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part1graph',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part1graph')(record)}>
            {configForm.getFieldValue(getName('part1type')(record)) !==
            'SUPERSET' ? (
              <ParListSelect
                parcode="CHARTTYPE"
                allowClear
                disabled={Params.part1show}
              />
            ) : (
              <ParValueExternalSelect
                parcode="SUPSETLIST"
                disabled={configForm.getFieldValue(getName('part1type')(record)) !== 'SUPERSET'}
              />
            )}
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part1view',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part1view')(record)}>
            <ParListSelect
              parcode="CHARTVIEW"
              allowClear
              disabled={Params.part1show}
            />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part1kpi',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part1kpi')(record)}>
            <ParListSelect
              parcode="STPRDKPI"
              allowClear
              disabled={Params.part1show}
            />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part2type',
        render: (value, record) => {
          Params.part1show = value !== 'Chart';
          return (
            <Form.Item noStyle name={getName('part2type')(record)}>
              <ParListSelect
                parcode="PARTTYPE"
                onChange={(e, k) => {
                  Params.part2show = e !== 'Chart';

                  if (e === 'SUPERSET') {
                    setValueByNamePath(
                      configForm,
                      getName('part2graph')(record),
                      ''
                    );
                    setValueByNamePath(
                      configForm,
                      getName('part2label')(record),
                      ''
                    );
                    setValueByNamePath(
                      configForm,
                      getName('part2view')(record),
                      ''
                    );
                    setValueByNamePath(
                      configForm,
                      getName('part2kpi')(record),
                      ''
                    );
                  }
                }}
                allowClear
              />
            </Form.Item>
          );
        },
        width: 200,
      },
      {
        dataIndex: 'part2width',
        render: (value, record) => (
          <Form.Item name={getName('part2width')(record)}>
            <InputNumber min={4} max={24} />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part2height',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part2height')(record)}>
            <InputNumber min={100} max={800} />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part2label',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part2label')(record)}>
            <Input />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part2graph',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part2graph')(record)}>
            {configForm.getFieldValue(getName('part2type')(record)) !==
            'SUPERSET' ? (
              <ParListSelect
                parcode="CHARTTYPE"
                allowClear
                disabled={Params.part1show}
              />
            ) : (
              <ParValueExternalSelect
                parcode="SUPSETLIST"
                disabled={configForm.getFieldValue(getName('part2type')(record)) !== 'SUPERSET'}
              />
            )}
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part2view',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part2view')(record)}>
            <ParListSelect
              parcode="CHARTVIEW"
              allowClear
              disabled={Params.part2show}
            />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part2kpi',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part2kpi')(record)}>
            <ParListSelect
              parcode="STPRDKPI"
              allowClear
              disabled={Params.part2show}
            />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part3type',
        render: (value, record) => {
          Params.part1show = value !== 'Chart';
          return (
            <Form.Item noStyle name={getName('part3type')(record)}>
              <ParListSelect
                parcode="PARTTYPE"
                onChange={(e, k) => {
                  Params.part3show = e !== 'Chart';

                  if (e === 'SUPERSET') {
                    setValueByNamePath(
                      configForm,
                      getName('part3graph')(record),
                      ''
                    );
                    setValueByNamePath(
                      configForm,
                      getName('part3label')(record),
                      ''
                    );
                    setValueByNamePath(
                      configForm,
                      getName('part3view')(record),
                      ''
                    );
                    setValueByNamePath(
                      configForm,
                      getName('part3kpi')(record),
                      ''
                    );
                  }
                }}
                allowClear
              />
            </Form.Item>
          );
        },
        width: 200,
      },
      {
        dataIndex: 'part3width',
        render: (value, record) => (
          <Form.Item name={getName('part3width')(record)}>
            <InputNumber min={4} max={24} />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part3height',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part3height')(record)}>
            <InputNumber min={100} max={800} />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part3label',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part3label')(record)}>
            <Input />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part3graph',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part3graph')(record)}>
            {configForm.getFieldValue(getName('part3type')(record)) !==
            'SUPERSET' ? (
              <ParListSelect
                parcode="CHARTTYPE"
                allowClear
                disabled={Params.part1show}
              />
            ) : (
              <ParValueExternalSelect
                parcode="SUPSETLIST"
                disabled={configForm.getFieldValue(getName('part3type')(record)) !== 'SUPERSET'}
              />
            )}
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part3view',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part3view')(record)}>
            <ParListSelect
              parcode="CHARTVIEW"
              allowClear
              disabled={Params.part3show}
            />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'part3kpi',
        render: (value, record) => (
          <Form.Item noStyle name={getName('part3kpi')(record)}>
            <ParListSelect
              parcode="STPRDKPI"
              allowClear
              disabled={Params.part3show}
            />
          </Form.Item>
        ),
        width: 200,
      },
      {
        dataIndex: 'userid',
        render: (value, record) => (
          <Form.Item noStyle name={getName('userid')(record)}>
            <Value />
          </Form.Item>
        ),
        width: 200,
      },
      {
        key: 'remove',
        fixed: 'right',
        render: (_, record) => (
          <Popconfirm
            title="Are you sure to delete this action?"
            onConfirm={() => {
              if (record.partid !== NEW_CONFIG_ID) {
                removeMguserlanding({
                  partid: record.partid,
                }).then(() => refetch());
              } else {
                remove(record.partid);
              }
            }}
            okText="Yes"
            cancelText="No"
          >
            <AntdButton size="small">Delete</AntdButton>
          </Popconfirm>
        ),
        width: 100,
      },
      {
        key: 'save',
        fixed: 'right',
        render: (_, record) =>
          record.partid === NEW_CONFIG_ID ? (
            <AntdButton size="small" onClick={() => onSave(record)}>
              Save
            </AntdButton>
          ) : (
            <AntdButton size="small" onClick={() => onSave(record)}>
              Update
            </AntdButton>
          ),
        width: 100,
      },
    ],
    [Params, getName, onSave, refetch, remove]
  );

  const addRow = () => {
    const row: MguserlandingResponse = {
      mgid: user.mgid,
      mgname: user.mgname,
      part1graph: '',
      part1height: 0,
      part1kpi: '',
      part1label: '',
      part1type: '',
      part1view: '',
      part1width: 0,
      partid: NEW_CONFIG_ID,
      partorder: 0,
      userid: user.id,
      part1graphLabel: '',
      part1kpiLabel: '',
      part1typeLabel: '',
      part1viewLabel: '',
      part2graph: '',
      part2height: 0,
      part2kpi: '',
      part2label: '',
      part2type: '',
      part2view: '',
      part2width: 0,
      part2graphLabel: '',
      part2kpiLabel: '',
      part2typeLabel: '',
      part2viewLabel: '',
      part3graph: '',
      part3height: 0,
      part3kpi: '',
      part3label: '',
      part3type: '',
      part3view: '',
      part3width: 0,
      part3graphLabel: '',
      part3kpiLabel: '',
      part3typeLabel: '',
      part3viewLabel: '',
    };
    add(row);
  };

  const onSaveOfquickActions = useCallback(
    (record: MgUsersFavoriteResponse) => {
      const functions: MgUsersFavoriteResponse[] =
        quickActionsForm.getFieldValue(fieldNameOfquickAction);
      const index = indexBy(functions, 'favoriteid')[record.favoriteid];
      const currentValue = functions[index];

      const { mgid, taskid, favoriteid } = currentValue;
      if (mgid) {
        favoriteid === NEW_ACTION_ID &&
          addFavorite({ request: { mgid, taskid } }).then((response) => {
            if (response.code === '200') {
              notification.success({
                message: `Created`,
              });
              refetchAction();
            } else {
              notification.error({
                message: response.message,
                description: response.description,
              });
            }
          });
      } else {
        notification.error({
          message: 'Please select Company',
        });
      }
    },
    [quickActionsForm, refetchAction]
  );
  const columnsOfquickActions = useMemo<
    DataGridColDef<MgUsersFavoriteResponse>[]
  >(
    () => [
      {
        dataIndex: 'mgid',
        render: (value, record) => {
          return record.favoriteid === NEW_ACTION_ID ? (
            <Form.Item noStyle name={getNameOfquickAction('mgid')(record)}>
              <MgCompanyList />
            </Form.Item>
          ) : (
            record.mgname
          );
        },
        width: 200,
      },
      {
        dataIndex: 'taskid',
        render: (value, record) => {
          return record.favoriteid === NEW_ACTION_ID ? (
            <Form.Item noStyle name={getNameOfquickAction('taskid')(record)}>
              <ListOfTasks />
            </Form.Item>
          ) : (
            record.tasklabel
          );
        },
        width: 200,
      },
      {
        key: 'remove',
        render: (_, record) => (
          <Popconfirm
            title="Are you sure to delete this action?"
            onConfirm={() => {
              if (record.favoriteid !== NEW_ACTION_ID) {
                removeFavorite({
                  favoriteid: record.favoriteid,
                }).then(() => refetchAction());
              } else {
                remove(record.favoriteid);
              }
            }}
            okText="Yes"
            cancelText="No"
          >
            <AntdButton size="small">Delete</AntdButton>
          </Popconfirm>
        ),
        width: 100,
      },
      {
        key: 'save',
        render: (_, record) =>
          record.favoriteid === NEW_ACTION_ID && (
            <AntdButton
              size="small"
              onClick={() => onSaveOfquickActions(record)}
              disabled={record.taskid === ('' as any)}
            >
              Save
            </AntdButton>
          ),
        width: 100,
      },
    ],
    [getNameOfquickAction, refetchAction, remove, onSaveOfquickActions]
  );

  const addRowOfquickActions = () => {
    const row: MgUsersFavoriteResponse = {
      favoriteid: NEW_ACTION_ID,
      id: 0,
      mgid: '' as any,
      taskid: '' as any,
      mgname: '',
      tasklabel: '',
    };
    addd(row);
  };

  const onProfileFormSubmit = (values: UserSessionParameters) => {
    updateMyWorkingSession({ request: values, userid: user.id }).then((res) => {
      localStorage.setItem('mgid', String(values.mgid));
      localStorage.setItem('mgname', String(mgName));
      notification.success({ message: res.message });
      window.location.reload();
    });
    i18next.changeLanguage(values.lancode);
  };

  return (
    <div style={{ height: '550px' }}>
      {/* <Spin spinning={isFetching}>
        <br />
        <br />
        <Row>
          <Col style={{ display: 'flex', justifyContent: 'start' }}>
            <Avatar size={130} icon={<UserOutlined />} />
          </Col>
          <Col span={1}></Col>
          <Col span={8} style={{ marginTop: '7px' }}>
            <h1
              style={{ fontSize: '45px', fontWeight: 'bold', marginBottom: 0 }}
            >
              {myProfileForm.getFieldValue('surname')}
            </h1>
            <h3>{myProfileForm.getFieldValue('email')}</h3>
          </Col>
          <Col span={7}></Col>
          <Col span={3}>
            <SaveButton
              size="middle"
              onClick={() => {
                onProfileFormSubmit(myProfileForm.getFieldsValue());
              }}
              comcode="save"
            />
          </Col>
        </Row>
        <br />
        <Form
          form={myProfileForm}
          layout="vertical"
          style={{ paddingLeft: '20px', paddingRight: '20px' }}
        >
          <Row>
            <Col span={24}>
              <Row gutter={[8, 0]}>
                <FormInput col xs={8} name="name">
                  <Input disabled />
                </FormInput>
                <FormInput col xs={8} name="username">
                  <Input disabled />
                </FormInput>
                <FormInput col xs={8} name="mgid">
                  <MgCompanyList onSelected={(mg) => SetmgName(mg.mgname)} />
                </FormInput>
                <FormInput col xs={8} name="tabposition">
                  <ParListSelect parcode="TABPOS" />
                </FormInput>
                <FormInput col xs={8} name="lancode">
                  <ParListSelect parcode="ULANCODE" />
                </FormInput>

                <FormInput col xs={8} name="route">
                  <ListOfLandingPages />
                </FormInput>
                <FormInput col xs={8} name="phone">
                  <Input disabled />
                </FormInput>
                <FormInput col xs={8} name="mobile">
                  <Input disabled />
                </FormInput>
                <FormInput col xs={8} name="usertype">
                  <ParListSelect disabled parcode="USERTYPE" />
                </FormInput>
              </Row>
            </Col>
          </Row>
        </Form>
      </Spin> */}

      {/* <div style={{ textAlign: 'right' }}>
        <Button
          size="middle"
          comcode="changePassword"
          icon={<LockTwoTone twoToneColor="#ff0000" />}
          onClick={() => {
            onCancel();
            navigate('/change-password');
          }}
        />
        <SaveButton size="middle" comcode="save" />
      </div> */}
      <br />
      {/* <Form form={quickActionsForm}>
        <Form.Item
          noStyle
          shouldUpdate={(
            prevValue: ValuesActions,
            nextValue: ValuesActions
          ) => {
            return !isEqual(prevValue, nextValue);
          }}
        >
          {({ getFieldValue }) => {
            const actions: MgUsersFavoriteResponse[] = getFieldValue(
              fieldNameOfquickAction
            );
            const isNewItemInTable =
              actions?.find(
                ({ favoriteid }) => favoriteid === NEW_ACTION_ID
              ) !== undefined;

            return (
              <DataGrid
                rowKey="favoriteid"
                dataSource={actions}
                columns={columnsOfquickActions}
                isLoading={isFetchingAction}
                titleComcode="quickActions"
                hideFilters
                extraActions={
                  <AntdButton
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={addRowOfquickActions}
                    disabled={isNewItemInTable}
                  >
                    Add NEW
                  </AntdButton>
                }
              />
            );
          }}
        </Form.Item>
      </Form> */}
      <br />

      <Form form={configForm}>
        <Form.Item
          noStyle
          shouldUpdate={(prevValue: Values, nextValue: Values) => {
            return !isEqual(prevValue, nextValue);
          }}
        >
          {({ getFieldValue }) => {
            const actions: MguserlandingResponse[] = getFieldValue(fieldName);
            const isNewItemInTable =
              actions?.find(({ partid }) => partid === NEW_CONFIG_ID) !==
              undefined;
            return (
              <DataGrid
                rowKey="partid"
                dataSource={actions}
                columns={columns}
                isLoading={isFetching}
                titleComcode="config"
                hideFilters
                extraActions={
                  <AntdButton
                    type="primary"
                    onClick={addRow}
                    disabled={isNewItemInTable}
                  >
                    Add
                  </AntdButton>
                }
              />
            );
          }}
        </Form.Item>
      </Form>
    </div>
  );
};

export default LandingPageConfig;
